import { memo } from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';

import ImageLoader from '../../../../molecules/Image';

import { uuidv4 } from '../../../../../utils/generic';
import { pushEventInLoggy } from '../../../../../utils/loggy';

import { exploreServiceContents } from './constant';

const Business = memo(({ isMobile, toggleLoginModal }) => (
  <div className='black row mx-0 w-100 h-100'>
    <div className='col-md-6 mb-4 text-left align-self-center'>
      <h1 className={classNames('black bold', isMobile ? 'font-28px' : 'font-50px')}>
        Elevate Your Business <br /> with On-Demand <br />
        Contract Professionals
      </h1>
      <div className={classNames(isMobile ? 'font-14px' : 'font-16px', 'mt-4 medium')}>
        Find promoters, sales agents, auditors and more with pan India coverage of our vendor network
      </div>
      {isMobile ? (
        <div className='explore-services m-r-l--15'>
          <div className='px-4 d-flex py-3 overflow-x-auto'>
            {exploreServiceContents.map((exploreServiceSubContents) => (
              <div key={uuidv4()}>
                {exploreServiceSubContents.map((elm) => (
                  <div key={elm.title}>
                    <div className='center-y bg-white explore-services__card br-8 px-3 mr-3 my-3' style={{ width: '150px', height: '50px' }}>
                      <img alt={elm.alt} height='24px' src={`/images/homepage/exportServices/${elm.image}.png`} width='24px' />
                      <div className='ml-3'>
                        <div className='font-10 semi-bold mb-2'>{elm.title}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : null}
      <div className='row mt-5'>
        <div className='col-md-5 col-12'>
          <div className='w-240px relative'>
            <button
              className='bg-yellow-2 border-0 w-100 font-16px py-3 br-4'
              onClick={() => {
                toggleLoginModal(true);
                pushEventInLoggy({ event: 'Hero_section_Post_Requirements_Click', user_role: 'Client', page_name: 'Landing page' });
              }}
            >
              Post your requirement
            </button>
            <img className='position-absolute' height={56} src='/gifs/sparks.gif' style={{ top: '-28px', right: '-28px' }} width={56} />
          </div>
        </div>
        <div className='col-md-7 d-flex col-12 mt-md-0 mt-4'>
          <div className='col-md-4 col-3 px-0 px-md-3'>
            <div className={classNames(isMobile ? 'font-32px' : 'font-32px', 'semi-bold green-2')}>50+</div>
            <div className='font-12px text-left'>Cities</div>
          </div>
          <div className='col-md-7 pl-md-0 ml-md-0 ml-4'>
            <div className={classNames(isMobile ? 'font-32px' : 'font-32px', 'semi-bold green-2')}>1000+</div>
            <div className='font-12px text-left'>Vendor partners</div>
          </div>
        </div>
      </div>
    </div>
    <div className='col-md-6 d-md-block d-none pr-0' style={{ height: '730px' }}>
      <ImageLoader
        alt='Group of people in an office meeting'
        layout='fill'
        objectFit='contain'
        priority={true}
        src={isMobile ? '/images/hero-banner.png' : '/images/hero-banner.png'}
      />
    </div>
    <style jsx>{`
      .w-240px {
        width: 240px;
      }
      .green-2 {
        color: #44abb6;
      }

      .explore-services__card {
        box-shadow: 0px 4px 25px 0px #0000001a;
      }
    `}</style>
  </div>
));

Business.displayName = 'Business';

const mapStateToProps = ({ my_profile }) => ({
  my_profile: my_profile.data
});

export default connect(mapStateToProps, {})(Business);
